import React, { useCallback, useEffect, useState } from "react";

import Container from "@material-ui/core/Container";
import { useParams, useRouteMatch } from "react-router-dom";
import ContentEditDialog from "./ContentEditDialog";

const ContentEdit = props => {
  const { onCancel, onSaveSuccess } = props;
  const { id } = useParams();
  const match = useRouteMatch();
  const [editVisible, setEditVisible] = useState(false);

  const handleSuccess = useCallback(() => {
    setEditVisible(false);
    onSaveSuccess();
  }, [onSaveSuccess]);

  const handleCancel = useCallback(() => {
    setEditVisible(false);
    onCancel();
  }, [onCancel]);

  useEffect(() => {
    if (match.isExact) {
      setEditVisible(true);
    } else {
      setEditVisible(false);
    }
  }, [match]);

  return (
    <Container>
      <ContentEditDialog
        id={id}
        visible={editVisible}
        onCancel={handleCancel}
        onSaveSuccess={handleSuccess}
      />
    </Container>
  );
};

export default ContentEdit;
